import { Button } from '../common/Button';

export interface BulkActionBarProps {
  selectedCount: number;
  hasGrantEligible: boolean;
  hasRevokeEligible: boolean;
  onGrant: () => void;
  onRevoke: () => void;
  onClear: () => void;
}

export function BulkActionBar(props: BulkActionBarProps) {
  if (props.selectedCount === 0) return null;

  const cellLabel = `${props.selectedCount} cell${props.selectedCount !== 1 ? 's' : ''} selected`;

  return (
    <div
      role="region"
      aria-label="Bulk action bar"
      className="fixed bottom-0 inset-x-0 z-40 bg-white border-t border-gray-200 shadow-lg
                 transition-transform duration-200 ease-in-out translate-y-0
                 px-4 py-3 flex items-center justify-between gap-4"
    >
      <span className="text-sm font-semibold text-gray-900">{cellLabel}</span>
      <div className="flex items-center gap-2">
        <Button variant="primary" disabled={!props.hasGrantEligible} onClick={props.onGrant}>
          Grant
        </Button>
        <Button variant="danger" disabled={!props.hasRevokeEligible} onClick={props.onRevoke}>
          Revoke
        </Button>
        <button
          type="button"
          onClick={props.onClear}
          className="px-3 py-2 text-sm font-medium text-gray-600 hover:text-gray-800"
        >
          Clear
        </button>
      </div>
    </div>
  );
}
